import { makeObservable, observable, action, reaction, toJS, when } from 'mobx';
import axios from 'axios';
import { animateScroll } from 'react-scroll';
import {  stores } from "../history_mobx";
import qs from "qs";

class commentsStore {
  list={inited:false,fetching:false,data:[]};
  last_readed=false;
  reply_to=0;
  category=0;
  element=0;
  scrolltoId=0;
  new_comments=0;
  topic_starter=0;
  standalone=0;
  offset=0;
  limit=100;
  initial_limit=100;
  before_load_last_id=0;
  editor_css=null;
  scroll_save={};
  readed={};
  reactions=[];
  comment_url_var='comment';
  comment_not_found=0;
  hidden_comments={};
  hidden_counters={};
  readonly=false;
  small_mode=false;
  selected_comment=null;

  constructor(par, options={}) {
    this.par=par;
    this.comment_url_var=options.comment_url_var || 'comment';

    makeObservable(this, {
      list: observable,
      reply_to: observable,
      category: observable,
      element: observable,
      scrolltoId: observable,
      last_readed: observable,
      new_comments: observable,
      topic_starter: observable,
      standalone: observable,
      readed: observable,
      editor_css: observable,
      comment_not_found: observable,
      hidden_comments: observable,
      hidden_counters: observable,
      readonly: observable,
      small_mode: observable,
      selected_comment: observable,
      setRootElement: action,
      loadComments: action,
      mergeArrayAnswer:action,
      closeTree:action,
      openTree:action,
    });

    this.reactions.push(reaction(()=>{
      return stores.router.location;
    },(loc)=>{
      const data=loc.search;
      const ex = data.split('?');
      const parsed = qs.parse(ex[1]);
      this.selected_comment=parsed[this.comment_url_var];
      if(parsed[this.comment_url_var]) {
        this.moveToCommentId(parsed[this.comment_url_var]);
      }
    }));

    if(stores.router.location) {
      const parsed=qs.parse(stores.router.location.search,{ ignoreQueryPrefix:true });
      if(parsed[this.comment_url_var]) {
        this.selected_comment = parsed[this.comment_url_var];
      }
    }

  }
  moveToSelectedCommentInStore() {
    this.moveToCommentId(this.selected_comment);
  }
  readMessage() {

  }
  getParentTree(rootId) {
    let rootComment=this.list.data.items.filter((item)=>{
      return item._id == rootId;
    });
    if(rootComment[0]) {
      rootComment = rootComment[0];

      const hidedenComments = this.list.data.items.filter((item) => {
        return item.left_key <= rootComment.left_key && item.right_key >= rootComment.right_key;
      });

      return {
        root: rootComment,
        tree: hidedenComments
      }
    }
    return false;
  }
  getTree(rootId) {
    let rootComment=this.list.data.items.filter((item)=>{
      return item._id == rootId;
    });
    if(rootComment[0]) {
      rootComment = rootComment[0];

      const hidedenComments = this.list.data.items.filter((item) => {
        return item.left_key >= rootComment.left_key && item.right_key <= rootComment.right_key;
      });

      return {
        root: rootComment,
        tree: hidedenComments
      }
    }
    return false;
  }
  closeTree(rootId) {
    const tree=this.getTree(rootId);
    if(tree) {
      for(let i in tree.tree) {
        this.hidden_comments[tree.tree[i]._id]=1
      }
      this.hidden_counters[tree.root._id] = tree.tree.length
      axios.post(`/api/comments/${this.category}/${this.element}/close_tree/${rootId}`);
    }
  }
  prepareClosedTree() {
    if(this.list.data.closed && this.list.data.closed.length) {
      for(let i in this.list.data.closed) {
        this.closeTree(this.list.data.closed[i]);
      }
    } else {
      for(let commentId in this.hidden_counters) {
        this.closeTree(commentId);
      }
    }
  }
  openTree(rootId) {
    const tree=this.getTree(rootId);
    if(tree) {
      for(let i in tree.tree) {
        delete(this.hidden_comments[tree.tree[i]._id]);
      }
      delete(this.hidden_counters[tree.root._id]);
      axios.post(`/api/comments/${this.category}/${this.element}/open_tree/${rootId}`);
    }
  }
  commentIdExists(id) {
    for(let i in this.list.data.items) {
      if(this.list.data.items[i]._id === id) {
        return true;
      }
    }
    return false;
  }
  moveToSelectedComment() {
    const data = stores.router.location.search;
    const ex = data.split('?');
    const parsed = qs.parse(ex[1]);
    if (parsed[this.comment_url_var]) {
      if(!this.commentIdExists(parsed[this.comment_url_var])) {
        if(this.list.data.have_before) {
          this.loadBefore(true).then(() => {
            this.moveToSelectedComment();
          });
        } else {
          this.comment_not_found=true;
        }
      } else {
        this.moveToCommentId(parsed[this.comment_url_var]);
      }
    }
  }

  destruct()
  {
    for(let i in this.reactions) {
      this.reactions[i]();
    }
  }
  setTopicStarter(starter)
  {
    this.topic_starter=starter;
  }
  countNewComments(arr)
  {
    if(arr.items && arr.items.length > 0) {
      let cnt=0;
      for(let i in arr.items) {
        if(arr.items[i].new_comment && !this.readed[arr.items[i]._id]) {
          cnt++;
        }
      }
      return cnt;
    }
    return 0;
  }
  loadAll() {
    this.loadComments(false, { load_all: true, fetching:'before', type:"all" });
  }
  loadBefore(disableScrooll) {
    this.limit+=this.initial_limit;
    return this.loadComments(false, { limit: this.limit, fetching:'before', disable_scroll:disableScrooll });
  }
  loadComments(update_last_readed=false, opts={}) {
    this.list.fetching=opts.fetching || true;
    let add='';
    let q={};
    if(update_last_readed) {
      q.update_last_readed=1;
    } else {
      if(this.last_readed) {
        q.use_last_readed=this.last_readed;
      }
    }
    if(opts.load_all) {
      q.load_all=1;
    } else {
      if (opts.offset) {
        q.offset = opts.offset;
      }
      if (opts.limit) {
        q.limit = opts.limit;
      } else {
        if (this.limit) {
          q.limit = this.limit;
        }
      }
    }
    add='?'+qs.stringify(q);

    return axios.get(`/api/comments/${this.category}/${this.element}${add}`).then((item) => {
      this.mergeArrayAnswer(item,opts)
    });
  }
  loadLastComboComments() {
    this.list.fetching=true;
    const opts={
      limit: 5
    };
    const w=qs.stringify(opts);
    return axios.get(`/api/comments/last_combo_comments?${w}`).then((item) => {
      this.mergeArrayAnswer(item,opts)
    });
  }
  loadLastComments(opts={}) {
    this.list.fetching=true;
    const w=qs.stringify(opts);
    return axios.get(`/api/comments/last_comments?${w}`).then((item) => {
      this.mergeArrayAnswer(item,opts)
    });
  }
  getScrollOb() {
    return document.getElementById("centerScrollerScroll") || document.getElementsByTagName("html")[0]
  }
  mergeArrayAnswer(item, opts={}) {
    // if (opts.load_all || !this.list.inited) {
    if(this.list.inited) {
      if(!opts.disable_scroll && opts.fetching == "before") {
        const scrollOb=this.getScrollOb();
        this.scroll_save = {
          enable: 1,
          scroll_top: scrollOb.scrollTop,
          scroll_height: scrollOb.scrollHeight,
          type: opts.type
        };
      }
    }
    this.list.fetching = false;
    this.list.data = item.data.answer;
    this.prepareClosedTree();
    this.list.inited = true;
    this.new_comments = this.countNewComments(item.data.answer);
    if (item.data.answer.last_readed) {
      this.last_readed = item.data.answer.last_readed;
    }

    /*when(()=>{
      return this.list.data.items[0];
    },()=>{
      console.log("when fired!");
      setTimeout(()=>{
        this.moveToSelectedComment();
      },1000);
    });*/



      // console.log('MERGED LOADED', toJS(this.list.data.items));
    // } else {
      /*this.scroll_save={
        enable:1,
        scroll_top:document.getElementsByTagName("html")[0].scrollTop,
        scroll_height:document.getElementsByTagName("html")[0].scrollHeight
      };
      this.before_load_last_id=toJS(this.list.data.items[0]._id);
      this.list.data.items.unshift.apply(this.list.data.items, item.data.answer.items);
      this.list.data.have_before = item.have_before;
      this.list.data.have_after = item.have_after;*/

/*      when(()=>{
        return this.list.data.items[0];
      },()=>{
        console.log("when fired!");
        setTimeout(()=>{
          this.moveToCommentId(lastId);
        },3000);
      });*/
      /*setTimeout(()=>{

      },100);*/
      // console.log('MERGED', item.data.items,'+', toJS(this.list.data.items));
    // }
  }
  replyTo(commentArr) {
    this.reply_to=commentArr;
  }
  setRootElement(category,element)
  {
    this.category=category;
    this.element=element
  }
  deleteComment(id) {
    return axios.delete(`/api/comments/${id}`).then((item)=>{
      if(item.data.answer) {
        this.loadComments();
      } else {

      }
    })
  }
  moveToNextNewComment() {
    for(let i in this.list.data.items) {
      const cur=this.list.data.items[i];
      if(cur.new_comment && !this.readed[cur._id]) {
        this.moveToCommentId(cur._id,()=>{

        });
        cur.new_comment=false;
        this.readed[cur._id]=1;
        this.new_comments--;
        return true;
      }
    }
  }
  revealComment(commentId) {
    return new Promise((resolve, reject)=>{
      const par=this.getParentTree(commentId);
      let was=false;
      for(let i in par.tree) {
        if(this.hidden_counters[par.tree[i]._id]) {
          was=true;
          when(()=>{
            return this.hidden_counters[par.tree[i]._id];
          },()=>{
            resolve();
          });
          this.openTree(par.tree[i]._id);
        }
      }
      if(!was) {
        resolve();
      }
    });

  }
  moveToCommentId(newCommentId,callback=()=>{}) {
    this.revealComment(newCommentId).then(()=>{
      const commentDomElement=document.querySelector(`[name="comment-${newCommentId}"]`);
      if(commentDomElement) {
        let oTop = commentDomElement.offsetParent.offsetTop;
        const height = document.querySelector(`[name="comment-${newCommentId}"]`).clientHeight;
        oTop = oTop - window.innerHeight / 2 + height / 2
        if (document.getElementById("centerScrollerScroll")) {
          animateScroll.scrollTo(oTop, {containerId: 'centerScrollerScroll', isDynamic: true, duration: 300});
        } else {
          animateScroll.scrollTo(oTop, {isDynamic: true, duration: 300});
        }
        if (commentDomElement) {
          setTimeout(() => {
            commentDomElement.classList.add("blinkElement");
            setTimeout(() => {
              commentDomElement.classList.remove("blinkElement");
              callback();
            }, 1000);
          }, 300)
        }
      }
    });
  }
  commentPosted(newCommentId) {
    if(this.category && this.element) {
      this.loadComments().then(() => {
        this.moveToCommentId(newCommentId);
      });
    }
  }

}

export default commentsStore;
